import React from 'react';
import '../styles/SuccessModal.css';

const SuccessModal = ({ onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="success-modal">
        <button className="close-button" onClick={onClose}>&times;</button>
        
        <div className="success-icon">🎉</div>
        <h2>You're On The Waitlist!</h2>
        
        <p className="success-message">
          Thank you for joining our waitlist! We're currently onboarding new users in batches to ensure everyone gets the best experience.
        </p>
        
        <p className="wait-info">
          <strong>What happens next?</strong><br />
          We'll notify you as soon as your access is ready. While you wait, we'll send you exclusive tips on business automation to get you prepared.
        </p>
        
        <div className="social-connect">
          <p>Join our community for early access and updates:</p>
          <div className="channel-buttons">
            <a href="https://t.me/+ICdLJrgFhb9hZTU0" target="_blank" rel="noopener noreferrer" className="channel-button telegram">
              <span className="icon">💬</span>
              Telegram Channel
            </a>
          </div>
        </div>
        
        <button className="close-modal-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
